import React from 'react';
import ContentLoader from 'react-content-loader';
import _ from 'underscore';
import './style.scss';
import { CardPlaceholderType } from './types';

interface CardPlaceholder {
    type: string;
    quantity: number;
    direction?: 'vertical' | 'horizontal';
    loading: boolean;
}

interface ProsCard {
    quantityArr: number[];
}

const ContentCardPlaceHolder = ({ quantityArr }: ProsCard) => {
    return (
        <>
            {quantityArr.map(() => {
                return (
                    <div className="content-card-placeholder" key={_.uniqueId('card_')}>
                        <ContentLoader backgroundColor="#E6E6E6" foregroundColor="#f2f2f2" height={198} speed={1} viewBox="0 0 468 198" width={468}>
                            <rect height="20" rx="15" ry="15" width="68" x="18" y="15" />
                            <rect height="24" rx="5" ry="5" width="294" x="18" y="42" />

                            <rect height="16" rx="5" ry="5" width="294" x="18" y="74" />
                            <rect height="16" rx="5" ry="5" width="294" x="18" y="94" />

                            <rect height="16" rx="0" ry="0" width="133" x="18" y="126" />

                            <rect height="8" rx="0" ry="0" width="34" x="18" y="150" />
                            <rect height="8" rx="0" ry="0" width="34" x="93" y="150" />

                            <rect height="110" rx="5" ry="5" width="110" x="332" y="15" />
                            <rect height="32" rx="4" ry="4" width="110" x="332" y="133" />
                        </ContentLoader>
                    </div>
                );
            })}
        </>
    );
};

const CardPlaceholder = ({ type, quantity, direction, loading }: CardPlaceholder) => {
    const arrQty = Array.from({ length: quantity } as number[]);

    return loading ? (
        <div className={`d-flex ${direction === 'horizontal' ? 'flex-row' : 'flex-column'}`}>
            {type === CardPlaceholderType.CONTENT_CARD && <ContentCardPlaceHolder quantityArr={arrQty} />}
        </div>
    ) : null;
};

export default CardPlaceholder;
